/* eslint-disable @typescript-eslint/no-unused-vars */
import Drawer from '@mui/material/Drawer'
// import { styled } from '@mui/material/styles'
// import { SwipeableDrawerProps } from '@mui/material/SwipeableDrawer'
import useResponsive from 'src/hooks/useResponsive'
import { drawerWidth, useLayoutContext } from 'src/layouts/VerticalLayout'

// const StyledDrawer = styled(Drawer)<SwipeableDrawerProps>({
//   overflowX: 'hidden',
//   '& ul': {
//     listStyle: 'none',
//   },
//   '& .MuiListItem-gutters': {
//     paddingLeft: 4,
//     paddingRight: 4,
//   },
// })

const DrawerComponent = (props: { children: React.ReactNode }) => {
  const { navState, setNavHandle } = useLayoutContext()
  const { isMobile } = useResponsive()

  const DesktopDrawerProps = {
    onOpen: () => null,
    onClose: () => setNavHandle?.(),
  }

  return (
    <Drawer
      open={isMobile ? navState : true}
      variant={'persistent'}
      anchor="left"
      {...DesktopDrawerProps}
      PaperProps={{
        sx: {
          borderTopRightRadius: 12,
          borderBottomRightRadius: 12,

          width: isMobile ? '100%' : drawerWidth,
          transition: 'width 200ms',

          backgroundColor: 'navigationMenu.background',
          borderRight: (theme) => `${1}px solid ${theme.palette.divider}`,

          '& .MuiDrawer-paper': {
            width: isMobile ? '100%' : drawerWidth,
            boxSizing: 'border-box',
          },

          '.padding': {
            ml: -3,
            transition: '0.15s',
          },
          '.opacity': {
            opacity: { xs: 1, md: 0 },
            transition: '0.15s',
          },

          '.disappear': {
            display: 'none',
          },

          '.height': {
            transition: '0.15s',
          },

          pb: 12,
          ...(isMobile
            ? {}
            : {
                '&:hover': {
                  width: 255,

                  '.disappear': {
                    display: 'flex',
                  },

                  '.height': {
                    height: 'auto !important',
                  },

                  '.opacity': {
                    opacity: 1,
                  },

                  '.padding': {
                    ml: 0,
                  },
                },
              }),
        },
      }}
    >
      {props.children}
    </Drawer>
  )
}

// fill 200ms cubic-bezier(0.4, 0, 0.2, 1);

export default DrawerComponent

// '.navIcon': {
//   width: '20%',
// },
// '.navItemsSchemaShowMore': {
//   height: '30px',
// },
// '.navText': {
//   width: '80%',
//   ml: 2,
// },
// '.navItemCollapse': {
//   maxHeight: 'none',
//   opacity: 1,

//   display: 'block',
// },

/// HOVER

// '.navItemCollapse': {
//   // display:'none',
//   overflow: 'hidden',
//   opacity: 0,
//   maxHeight: '0px',
//   transition: 'opacity 0.2s ease-in-out',
//   transitionDelay: '0.2s',
// },
// '.navIcon': {
//   width: '100%',
// },

// '.navText': {
//   width: 0,
// },
// '.navItemsSchemaShowMore': {
//   height: '0px',
// },
